import { useQuery } from '@tanstack/react-query';
import { AssessmentTypeService } from '../AssessmentTypeService';

export const useAssessmentTypes = () =>
  useQuery({
    queryKey: ['assessment-types', 'list'],
    queryFn: () => AssessmentTypeService.listAssessmentTypes(),
  });

// Not used by the AssessmentTypes list/edit page today (edit works off the row
// already loaded from the list) — kept for a future detail view or deep link.
export const useAssessmentType = (code) =>
  useQuery({
    queryKey: ['assessment-types', 'detail', code],
    queryFn: () => AssessmentTypeService.getAssessmentType(code),
    enabled: !!code,
  });
